// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".av-top-view[data-v-2dfec895]{padding-top:2.875rem;padding-bottom:3.125rem;font-size:16px;font-family:Arial,Helvetica,\"sans-serif\"}", ""]);
// Exports
module.exports = exports;
